import React, { useState } from 'react'
import { ROUTE } from 'shared-constants'
import SignInExpert from '@expert/routes/SignInExpert'
import { Box, Flex } from 'components/Layout'
import { StyledLink } from 'components/Link'
import { Text } from 'components/Typography'
import { COLOR_INTENT, COLOR_NAMES, FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'

export const AddToFavoritesExpertSignUp = ({
  setIsModalOpen,
}: {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  const [isSignInActive, setIsSignInActive] = useState(false)
  return (
    <Box>
      {isSignInActive ? (
        <Box>
          <SignInExpert
            isSignUpVisible={false}
            onSignUpCompleted={() => setIsModalOpen(false)}
          />
          <Text
            color={COLOR_INTENT.SIGN_IN.TEXT}
            fontSize={FONT_SIZE.PX_12}
            mt={SPACE.PX_15}
            textAlign="center"
            as="p"
          >
            Don&apos;t have an account?{' '}
            <Text
              as="span"
              role="button"
              color={COLOR_NAMES.PINEY_LAKE}
              fontSize={FONT_SIZE.PX_12}
              onClick={() => setIsSignInActive(false)}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Sign up.
            </Text>
          </Text>
        </Box>
      ) : (
        <Box mt={SPACE.PX_20}>
          <Text
            fontSize={FONT_SIZE.PX_18}
            color={COLOR_NAMES.EEIRE_BLACK}
            fontWeight={FONT_WEIGHT.MEDIUM}
            textAlign="center"
            as="p"
          >
            New to The Expert?
          </Text>
          <Flex justifyContent="center">
            <Text
              textAlign="center"
              as="p"
              style={{ maxWidth: '266px' }}
              mt={SPACE.PX_6}
              lineHeight="2"
            >
              Apply to join our Trade membership. You will not be able to
              Favorite products until after you are approved.
            </Text>
          </Flex>
          <StyledLink
            width="100%"
            mt={SPACE.PX_20}
            href={`${ROUTE.TRADE()}#form`}
            onClick={() => setIsModalOpen(false)}
          >
            Apply
          </StyledLink>
          <Text
            color={COLOR_INTENT.SIGN_IN.TEXT}
            fontSize={FONT_SIZE.PX_12}
            mt={SPACE.PX_15}
            textAlign="center"
            as="p"
          >
            Already have an account?{' '}
            <Text
              as="span"
              role="button"
              color={COLOR_NAMES.PINEY_LAKE}
              fontSize={FONT_SIZE.PX_12}
              onClick={() => setIsSignInActive(true)}
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Sign in.
            </Text>
          </Text>
        </Box>
      )}
    </Box>
  )
}
